import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import CustomList from '../../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../../config/config';
import { loadData } from '../../../../core/components/core/Util/List/CustomList/loadData';

import { selectionProcessStatusCell } from '../../../helpers/selectionProcessStatusCell';

function List() {
    const navigate = useNavigate();
    const pathFrontEnd = '/psp-selectionprocesses/';
    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${config.endpoints.backend}psp/selectionprocesses/delete`,
        endpoint: `${config.endpoints.backend}psp/selectionprocesses/getall`
    };

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            {
                name: 'status',
                type: 'select',
                label: 'Status',
                columnSize: 4,
                options: [
                    { label: 'Em breve', value: 'em_breve' },
                    { label: 'Período de Inscrição', value: 'inscricao' },
                    { label: 'Inscrições Encerradas', value: 'inscricao_encerrada' },
                    { label: 'Etapa de Provas', value: 'provas' },
                    { label: 'Análise de Resultados', value: 'analise_resultados' },
                    { label: 'Envio de Documentos', value: 'documentos' },
                    { label: 'Resultado Parcial', value: 'resultado_parcial' },
                    { label: 'Resultado Final', value: 'resultado_final' }
                ],
                validations: { required: false }
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            }
        ]
    };

    let list = {
        labelTitle: 'Lista de Processos Seletivos',
        labelTitleButtonAdd: 'Incluir novo processo seletivo',
        fieldsShowOnDelete: ['title'],
        formFilters: filters,
        columns: [
            {
                name: 'title',
                label: 'Título do Processo Seletivo',
                sortable: true
            },
            {
                name: 'edital_number',
                label: 'Número do Edital',
                sortable: true,
                cell: (row) => row.edital_number || '-'
            },
            {
                name: 'status',
                label: 'Status Atual',
                sortable: true,
                cell: selectionProcessStatusCell
            },
            {
                name: 'vacancies_count',
                label: 'Vagas',
                sortable: false,
                width: '8%'
            }
        ],
        columnsButtons: [
            {
                buttons: [
                    {
                        label: 'Vagas',
                        icon: 'fas fa-briefcase',
                        className: 'btn btn-outline-primary btn-sm btn-action mr-1',
                        onClick: (item) => {
                            navigate(`/psp-selectionprocesses/${item.id}/vacancies/list`);
                        }
                    }
                ]
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}

export default List;
